module.exports = __webpack_public_path__ + "media/images/error/maintenance-76cfdb14678cdbab9da130115691e4bf.svg";